import { Button } from '@karnov/kui-react'
import { FC, useCallback } from 'react'

import { useLocation } from 'react-router-dom'

import { useLoginProvider } from 'hooks/useLoginProvider'
import { useOriginalUrl } from 'hooks/useOriginalUrl'

import { useTranslation } from 'services/i18n'

export const RefreshAccess: FC = () => {
  const { t } = useTranslation('translation', {
    keyPrefix: 'no_access.refresh_access',
  })

  const { pathname, search } = useLocation()
  const { setOriginalUrl } = useOriginalUrl()
  const { redirectToLogin } = useLoginProvider()

  const handleRedirectToLogin = useCallback(() => {
    const originalUrl = `${pathname}${search}`
    setOriginalUrl(originalUrl)
    redirectToLogin()
  }, [redirectToLogin, setOriginalUrl, pathname, search])

  return (
    <div className="space-y-6">
      <p className="text-sm">
        {t('description')}
      </p>
      <Button
        onClick={handleRedirectToLogin}
        variant="primary"
      >
        {t('button')}
      </Button>
      <p className="text-sm">
        {t('contact_support')}
      </p>
    </div>
  )
}
